var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.507 6.07089C16.1238 4.93536 14.1311 4.93535 12.7479 6.07089L6.0411 11.5771C5.4627 12.052 5.12744 12.761 5.12744 13.5093V22.5C5.12744 23.8808 6.24673 25 7.62744 25H22.6274C24.0082 25 25.1274 23.8808 25.1274 22.5V13.5093C25.1274 12.761 24.7922 12.052 24.2138 11.5771L17.507 6.07089ZM11.1616 4.13865C13.4668 2.2461 16.7881 2.2461 19.0933 4.13866L25.8001 9.64488C26.9569 10.5946 27.6274 12.0126 27.6274 13.5093V22.5C27.6274 25.2615 25.3889 27.5 22.6274 27.5H7.62744C4.86602 27.5 2.62744 25.2615 2.62744 22.5V13.5093C2.62744 12.0126 3.29795 10.5946 4.45476 9.64488L11.1616 4.13865Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1274 20C10.1274 17.9289 11.8064 16.25 13.8774 16.25H16.3774C18.4485 16.25 20.1274 17.9289 20.1274 20V26.25H17.6274V20C17.6274 19.3096 17.0678 18.75 16.3774 18.75H13.8774C13.1871 18.75 12.6274 19.3096 12.6274 20V26.25H10.1274V20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.52225aa846324b6390ec86c6a66c0d36.svg";
export { ForwardRef as ReactComponent };